<template>
    <v-container :class="['mx-auto', 'mb-6']" style="max-width: 1540px"   :key="idDialog">
  <v-card
    outlined
  
  
  >
    <v-row no-gutters>
      <v-col cols="12" md="4">
        <v-list-item three-line>
          <v-list-item-content>
            <v-list-item-title
              :class="[
                'title',
                {
                  'text-center': $vuetify.breakpoint.smAndDown,
                },
              ]"
              >AGENDA DE VISITAS
              <span v-if="$refs.calendar" class="text-uppercase">
                {{ $refs.calendar.title }}
              </span></v-list-item-title
            >
            <v-list-item-subtitle>
              <comboCliente class="mt-3" :readon="false" />
            </v-list-item-subtitle>
            <v-list-item-subtitle class="py-2 font-weight-bold text-subtitle-2">
              {{ `Cliente: [${idCliente}] ${nbCli}` }}
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </v-col>
    </v-row>

    <v-toolbar dense class="elevation-1">
      <v-btn
        icon
        outlined
        :disabled="annioActual(value)"
        class="mx-1"
        small
        color="primary"
        @click="() => ($refs.calendar.prev(), setAgenda(idDist, idCliente))"
      >
        <v-icon large> mdi-chevron-left </v-icon>
      </v-btn>

      <v-btn
        icon
        outlined
        :disabled="mesActual(value, fecha_hoy)"
        class="ma-4"
        small
        color="primary"
        @click="() => ($refs.calendar.next(), setAgenda(idDist, idCliente))"
      >
        <v-icon large> mdi-chevron-right </v-icon>
      </v-btn>
      <v-divider vertical inset></v-divider>
      <v-btn
        class="mx-2"
        color="success"
        small
        @click="
          set_dialogNewVisit(true);
          showcal = true;
          idform++;
        "
      >
        Nueva Visita
        <v-icon right> mdi-plus-box-outline </v-icon>
      </v-btn>
      <v-divider vertical inset></v-divider>
      <v-btn
        small
        color="accent"
        dark
        class="mx-1"
        @click="() => datos(idDist)"
      ><!-- $router.go(-1)  -->
        Ver Clientes <v-icon right>mdi-arrow-left</v-icon>
      </v-btn>
      <v-spacer></v-spacer>
    </v-toolbar>

    <v-sheet class="mb-5 py-4">
      <v-calendar
        ref="calendar"
        v-model="value"
        :weekdays="weekday"
        :locale="localidad"
        type="month"
        :events="events"
        :now="fecha_hoy"
        :event-overlap-mode="mode"
        :event-overlap-threshold="30"
        :event-color="getEventColor"
        color="primary"
        @change="getEvents"
        @click:event="showEvent"
        @click:date="viewDay"
      >
        <template v-slot:event="{ event }">
          <div class="text-center">
            {{ event.name }}
          </div>
        </template>
      </v-calendar>
    </v-sheet>
    <v-dialog v-model="selectedOpen" scrollable max-width="650px" persistent>
      <v-card color="grey lighten-4" flat>
        <v-toolbar color="primary" dark dense height="30">
          <v-btn icon>
            <v-icon>mdi-pencil</v-icon>
          </v-btn>
          <v-toolbar-title
            v-html="
              `${selectedEvent.name} ${selectedEvent.DesVisita} N° ${selectedEvent.NumVisita}`
            "
          ></v-toolbar-title>
          <v-spacer></v-spacer>

          <v-btn icon @click="selectedOpen = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text style="height: 500px">
          <v-window v-model="step">
            <v-window-item :value="1">
              <v-list>
                <v-list-item>
                  <v-list-item-subtitle
                    class="
                      black--text
                      ml-n2
                      mt-n4
                      font-weight-bold
                      text-subtitle-1
                    "
                    >{{
                      `[${selectedEvent.Cliente}] ${selectedEvent.NombreCli}`
                    }}</v-list-item-subtitle
                  >
                </v-list-item>
                <v-divider class="mt-n3"></v-divider>
                <v-list-item class="mt-n3 ml-n2">
                  <v-list-item-subtitle
                    class="text-left font-weight-bold black--text"
                  >
                    {{ `Numero Visita: ` }}
                  </v-list-item-subtitle>
                  <v-list-item-subtitle class="text-right">
                    {{ `${selectedEvent.NumVisita}` }}
                  </v-list-item-subtitle>
                </v-list-item>
                <v-list-item class="mt-n6 ml-n2">
                  <v-list-item-subtitle
                    class="text-left font-weight-bold black--text"
                  >
                    {{ `Fecha Agenda: ` }}
                  </v-list-item-subtitle>
                  <v-list-item-subtitle class="text-right">
                    {{
                      `${moment(selectedEvent.FechaAgenda).format(
                        "DD/MM/YYYY"
                      )}`
                    }}
                  </v-list-item-subtitle>
                </v-list-item>
                <v-list-item class="mt-n6 ml-n2">
                  <v-list-item-subtitle
                    class="text-left font-weight-bold black--text"
                  >
                    {{ `Fecha Visita: ` }}
                  </v-list-item-subtitle>
                  <v-list-item-subtitle class="text-right">
                    {{
                      `${moment(selectedEvent.FechaVisita).format(
                        "DD/MM/YYYY"
                      )}`
                    }}
                  </v-list-item-subtitle>
                </v-list-item>

                <v-list-item class="mt-n6 ml-n2">
                  <v-list-item-subtitle
                    class="text-left font-weight-bold black--text"
                  >
                    {{ `Tipo Visita: ` }}
                  </v-list-item-subtitle>
                  <v-list-item-subtitle class="text-right">
                    {{
                      `${selectedEvent.DesVisita} (${selectedEvent.TipoVisita})`
                    }}
                  </v-list-item-subtitle>
                </v-list-item>

                <v-list-item class="mt-n6 ml-n2">
                  <v-list-item-subtitle
                    class="text-left font-weight-bold black--text"
                  >
                    {{ `Monto Cobrado: ` }}
                  </v-list-item-subtitle>
                  <v-list-item-subtitle class="text-right">
                    {{ `${selectedEvent.MontoCobrado}` }}
                  </v-list-item-subtitle>
                </v-list-item>

                <v-list-item class="mt-n6 ml-n2">
                  <v-list-item-subtitle
                    class="text-left font-weight-bold black--text"
                  >
                    {{ `Pedidos: ` }}
                  </v-list-item-subtitle>
                  <v-list-item-subtitle class="text-right">
                    {{ `${selectedEvent.IndPedidos ? "SI" : "NO"}` }}
                  </v-list-item-subtitle>
                </v-list-item>
                <v-list-item class="mt-n6 ml-n2">
                  <v-list-item-subtitle
                    class="text-left font-weight-bold black--text"
                  >
                    {{ `Cobros: ` }}
                  </v-list-item-subtitle>
                  <v-list-item-subtitle class="text-right">
                    {{ `${selectedEvent.IndCobros ? "SI" : "NO"}` }}
                  </v-list-item-subtitle>
                </v-list-item>
                <v-list-item class="mt-n6 ml-n2">
                  <v-list-item-subtitle
                    class="text-left font-weight-bold black--text"
                  >
                    {{ `Presupuestos: ` }}
                  </v-list-item-subtitle>
                  <v-list-item-subtitle class="text-right">
                    {{ `${selectedEvent.IndPresupuesto ? "SI" : "NO"}` }}
                  </v-list-item-subtitle>
                </v-list-item>

                <v-list-item class="mt-n6 ml-n2">
                  <v-list-item-subtitle
                    class="text-left font-weight-bold black--text"
                  >
                    {{ `Publicidad: ` }}
                  </v-list-item-subtitle>
                  <v-list-item-subtitle class="text-right">
                    {{ `${selectedEvent.IndBoletin ? "SI" : "NO"}` }}
                  </v-list-item-subtitle>
                </v-list-item>
                <v-list-item class="mt-n6 ml-n2">
                  <v-list-item-subtitle
                    class="text-left font-weight-bold black--text"
                  >
                    {{ `Llamar Luego: ` }}
                  </v-list-item-subtitle>
                  <v-list-item-subtitle class="text-right">
                    {{ `${selectedEvent.IndLlamar ? "SI" : "NO"}` }}
                  </v-list-item-subtitle>
                </v-list-item>
                <v-list-item class="mt-n6 ml-n2" v-if="selectedEvent.Notas">
                  <v-list-item-subtitle
                    class="text-left font-weight-bold black--text"
                  >
                    {{ `Observaciones: ` }}
                  </v-list-item-subtitle>
                  <v-list-item-subtitle class="text-right">
                    <v-textarea
                      readonly
                      no-resize
                      rows="5"
                      name="input-7-1"
                      :value="selectedEvent.Notas"
                    ></v-textarea>
                  </v-list-item-subtitle>
                </v-list-item>
              </v-list>
            </v-window-item>
            <v-window-item :value="2">
              <v-card-text class="text-center pa-12">
                <span
                  :class="[
                    'font-weight-bold',
                    'grey--text',
                    'text--darken-1',

                    {
                      'text-h6': $vuetify.breakpoint.smAndDown,
                    },
                    {
                      'text-h5': $vuetify.breakpoint.mdAndUp,
                    },
                  ]"
                >
                  <v-icon>mdi-information-outline</v-icon> Seguro que desea
                  Eliminar?
                </span>
              </v-card-text>
            </v-window-item>
            <v-window-item :value="3">
              <v-card-text>
                <formEditAgenda
                  :idcli="idCliente"
                  :iddist="idDist"
                  :key="idform"
                  :edititem="selectedEvent"
                />
              </v-card-text>
            </v-window-item>
          </v-window>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            :color="step === 2 ? 'error' : 'success'"
            @click="
              step === 2
                ? eliminarVisita(
                    selectedEvent.NumVisita,
                    selectedEvent.Cliente,
                    idDist
                  )
                : step === 3
                ? editar(selectedEvent)
                : false
            "
            v-if="step !== 1"
          >
            {{ step === 2 ? `Eliminar ` : `Editar` }}
            <v-icon right v-if="step === 2">mdi-delete-forever</v-icon>
            <v-icon right v-if="step === 3">mdi-square-edit-outline</v-icon>
          </v-btn>
          <!--  :disabled="!selectedEvent.IndModificar" -->
          <v-btn
            :disabled="!selectedEvent.IndModificar"
            color="error"
            @click="step = 2"
            v-if="step === 1"
          >
            Eliminar
            <v-icon right>mdi-delete-forever</v-icon>
          </v-btn>
          <v-btn
            :disabled="!selectedEvent.IndModificar"
            color="success"
            @click="step = 3"
            v-if="step === 1"
          >
            Editar
            <v-icon right>mdi-square-edit-outline</v-icon>
          </v-btn>
          <v-btn
            text
            color="error"
            @click="selectedOpen = false"
            v-if="step === 1"
          >
            Salir
          </v-btn>
          <v-btn text color="info" @click="step = 1" v-if="step !== 1">
            Volver
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="DialgAgenda" scrollable max-width="600px" persistent>
      <formAddAgenda
        :idcli="idCliente"
        :iddist="idDist"
        :showcal="showcal"
        :fechavi="fechaVi"
        :key="idform"
      />
    </v-dialog>
    <v-overlay :value="loadingAgenda">
      <v-progress-circular
        indeterminate
        size="30"
        width="2"
        color="primary"
      ></v-progress-circular>
      <span class="ml-2 body-2 font-weight-normal">Por Favor, Espere... </span>
    </v-overlay>
    <v-snackbar
      color="error"
      v-model="snackbar"
      multi-line
      :timeout="-1"
      bottom
      centered
    >
      <p class="text-h6">
        {{
          `La Fecha debe ser Mayor o Igual  a la Fecha de Agenda: 
      ${moment(fechaAgnd).format("DD/MM/YYYY")} y Menor Igual que hoy: ${moment(
            fecha_hoy
          ).format("DD/MM/YYYY")}`
        }}
      </p>

      <template v-slot:action="{ attrs }">
        <v-btn fab small text v-bind="attrs" @click="snackbar = false">
          <v-icon size="30"> mdi-close </v-icon>
        </v-btn>
      </template>
    </v-snackbar>
  </v-card>
    </v-container>

</template>

<script>
import moment from "moment";
import { mapState, mapMutations, mapActions } from "vuex";
import comboCliente from "../components/AgendaClienteComboVisitas";
import formAddAgenda from "../components/AgendaFormAddVisit";
import formEditAgenda from "../components/AgendaFormEditVisit";
export default {
  async created() {
    await this.setAgenda(this.idDist, this.idCliente);

    window.scrollTo(0, 0);
  },
  data() {
    return {
      step: 1,
      fechaVi: "",
      fechaAgnd: "",
      idform: 0,
      showcal: false,
      dialog: false,
      annioSelect: "",
      annio: new Date()
        .toLocaleString("sv", { timeZoneName: "short" })
        .substr(0, 4),
      fecha_hoy: new Date()
        .toLocaleString("sv", { timeZoneName: "short" })
        .substr(0, 10), //fecha dia
      selectedEvent: {},
      selectedElement: null,
      selectedOpen: false,
      mode: "stack",
      modes: ["stack", "column"],
      weekday: [1, 2, 3, 4, 5, 6, 0],
      weekdays: [{ text: "Mon - Sun", value: [1, 2, 3, 4, 5, 6, 0] }],
      value: "",
      events: [],
      colors: ["orange", "accent"],
      names: ["Visita"],
      snackbar: false,
    };
  },
  components: {
    comboCliente,
    formAddAgenda,
    formEditAgenda,
  },
  methods: {
    ...mapMutations("mod_agendaset", ["set_dialogNewVisit"]),
      ...mapMutations(["setTabAgenda"]),
    ...mapMutations("mod_agendaquery", [
      "clr_dsAgenda",
      "clr_filterAgendaVisit",
      "clr_filterAgendatipo",
      "clr_filterAgendaciudad",
      "clr_dsAgendaVisitas",
      "set_loadingAgenda",
    ]),
    ...mapActions("mod_agendaquery", ["get_dsAgenda", "agendaVisitas"]),
    ...mapActions("mod_agendaset", ["visitaAgendaDel", "visitaAgenda"]),
    clearFilter() {
      this.clr_filterAgendaVisit();
      this.clr_filterAgendatipo();
      this.clr_filterAgendaciudad();
    },
    async datos(idv) {
      this.set_loadingAgenda(true);
      this.clr_dsAgendaVisitas();
      this.clearFilter();

      await this.agendaVisitas({ vendedor: idv, opc: 1 });

      if (this.$route.name !== `AgendaVista`) {
        this.$router.push({ path: `/agenda/` }).catch((err) => {});
        this.setTabAgenda(1);
      }
    },
    mesActual(fechaSel, fechaHoy) {
      console.log("messs");
      let arraySel = fechaSel.split(["-"]);
      let arrayHoy = fechaHoy.split(["-"]);
      this.annioSelect = arraySel[0];

      if (fechaSel === "") return arrayHoy[1] === arrayHoy[1];
      else return arraySel[1] === arrayHoy[1];
    },
    annioActual(fechaSel) {
      let arraySel = fechaSel.split(["-"]);
      let arrayHoy = this.fecha_hoy.split(["-"]);

      if (
        fechaSel !== "" &&
        arraySel[1] === "01" &&
        arrayHoy[0] === arrayHoy[0]
      )
        return true;
      /*  if (fechaSel === "") return arrayHoy[0] < arrayHoy[0];
      else return arraySel[0] < arrayHoy[0]; */
    },
    async editar(item) {
      let FechaVisita = this.fechaAgenda(item.FechaVisita);

      await this.visitaAgenda({
        numvisita: item.NumVisita,
        fecha: FechaVisita,
        cliente: item.Cliente,
        opc: 2,
        vendedor: item.Vendedor,
        TipoVisita: item.TipoVisita,
        notas: item.Notas,
        IndPedidos: item.IndPedidos,
        IndCobros: item.IndCobros,
        IndBoletin: item.IndBoletin,
        IndPresupuesto: item.IndPresupuesto,
        IndCall: item.IndLlamar,
        Acuerdos: item.Acuerdos,
        tipoper: 2,
      });
      this.selectedOpen = false;
      await this.setAgenda(item.Vendedor, item.Cliente);

      window.scrollTo(0, 0);
    },

    async eliminarVisita(idvis, idcli, iddis) {
      await this.visitaAgendaDel({
        numvisita: idvis,
        cliente: idcli,
      });
      this.selectedOpen = false;
      await this.setAgenda(iddis, idcli);

      window.scrollTo(0, 0);
    },
    viewDay({ date }) {
      //muestra ventana segun fecha agenda
      console.log(date);
      if (date <= this.fecha_hoy && date >= this.fechaAgnd) {
        this.idform++;
        this.fechaVi = date;
        this.value = date;
        this.showcal = false;
        this.set_dialogNewVisit(true);
        return true;
      } else {
        this.snackbar = true;
        return false;
      }
    },
    //idDist idCliente setAgenda(idDist, idCliente)

    async setAgenda(dist, cli) {
      this.clr_dsAgenda();
      let fechaSelected = this.value === "" ? this.fecha_hoy : this.value;
      let arrayHoy = fechaSelected.split(["-"]);
      let anio = arrayHoy[0],
        mes = arrayHoy[1];

      await this.get_dsAgenda({
        vendedor: dist,
        opc: 6,
        cliente: cli,
        mes: mes,
        anio: anio,
      });
      await this.getEvents();
    },

    showEvent({ nativeEvent, event }) {
      this.idform++;
      this.selectedEvent = {};
      const open = () => {
        this.selectedEvent = event;
        this.selectedElement = nativeEvent.target;
        requestAnimationFrame(() =>
          requestAnimationFrame(() => (this.selectedOpen = true))
        );
      };

      if (this.selectedOpen) {
        this.selectedOpen = false;
        requestAnimationFrame(() => requestAnimationFrame(() => open()));
      } else {
        open();
      }

      nativeEvent.stopPropagation();
    },
    getEventColor(event) {
      return event.color;
    },
    rnd(a, b) {
      return Math.floor((b - a + 1) * Math.random()) + a;
    },
    getEvents() {
      const events = [];

      let data = [];
      console.log(this.dsAgenda);
      const { ttmaevis } = this.dsAgenda;
      if (ttmaevis !== undefined) {
        data = this.dsAgenda.ttmaevis;

        data.forEach((item) => {
          this.fechaAgnd = item.FechaAgenda;
          const FechaAgenda = moment(item.FechaAgenda).format(
            "YYYY-MM-DD HH:mm:ss"
          );
          const FechaVisita = moment(`${item.FechaVisita}`).format(
            "YYYY-MM-DD HH:mm:ss"
          );

          events.push({
            name: this.names[0],
            start: FechaVisita,
            end: FechaVisita,
            DesVisita: item.DesVisita,
            Cliente: item.Cliente,
            NombreCli: item.NombreCli,
            TipoVisita: item.TipoVisita,
            FechaVisita: item.FechaVisita,
            FechaAgenda: item.FechaAgenda,
            IndPedidos: item.IndPedidos,
            IndCobros: item.IndCobros,
            IndBoletin: item.IndBoletin,
            IndPresupuesto: item.IndPresupuesto,
            IndLlamar: item.IndLlamar,
            IndModificar: item.IndModificar,
            NumPedidos: item.NumPedidos,
            NumPresupuesto: item.NumPresupuesto,
            MontoCobrado: item.MontoCobrado[this.tipoMoneda],
            Notas: item.Notas,
            Vendedor: item.Vendedor,
            Acuerdos: item.Acuerdos,
            NumVisita: item.NumVisita,
            color: this.colors[1],
            // timed: !allDay,
          });
        });
      } else {
        console.log(data);
      }

      this.events = events;
    },
  },
  watch: {
    selectedOpen() {
      this.step = 1;
    },
    validaUser() {
      this.validaUser;
    },
    deep: true,
    immediate: true,
  },
  computed: {
    ...mapState(["dataUser", "tipoMoneda", "simboloMoneda"]),
    ...mapState("mod_agendaquery", ["dsAgenda", "loadingAgenda", "localidad"]),
    ...mapState("mod_agendaset", ["dialogNewVisit", "idDialog"]),

    DialgAgenda: {
      get() {
        return this.dialogNewVisit;
      },
      set() {
        this.set_dialogNewVisit();
      },
    },

    linkAgenda() {
      return this.dataUser.TipoUsuario !== "C" ? true : false;
    }, //
    validaUser() {
      if (this.dataUser.IndAutenticado && this.linkAgenda) return true;
      else {
        this.$router.push({ path: `/` }).catch((err) => {});
        return false;
      }
    },
    idDist() {
      return parseInt(this.$route.params.dist);
    },

    nbCli() {
      let nbcli = "";
      if ("ttCliente" in this.dsAgenda) {
        nbcli = this.dsAgenda.ttCliente[0].nombre;
      }
      return nbcli;
    },
    idCliente() {
      return parseInt(this.$route.params.cli);
    },
    fechaAgenda: function () {
      return function (fecha) {
        return moment(fecha).format("DD/MM/YYYY");
      };
    },
  },
};
</script>

<style scoped>
.mm {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  border-radius: 2px;
  background-color: #1867c0;
  color: #ffffff;
  border: 1px solid #1867c0;
  font-size: 12px;
  padding: 3px;
  cursor: pointer;
  margin-bottom: 1px;
  left: 4px;
  margin-right: 8px;
  position: relative;
}

.my-event.with-time {
  position: absolute;
  right: 4px;
  margin-right: 0px;
}
</style>
